"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _broadcastCampaign = require('shared/validation/broadcastCampaign');





var _secureText = require('shared/constants/secureText');

 const messageTypeOptions = [
  {
    value: _broadcastCampaign.MessageType.SecureSMS,
    label: _secureText.SECURE_TEXT_LABEL,
    desc: _secureText.SECURE_BROADCAST_HINT,
  },
  {
    value: _broadcastCampaign.MessageType.InsecureSMS,
    label: _secureText.INSECURE_TEXT_LABEL,
    desc: _secureText.INSECURE_BROADCAST_HINT,
  },
]; exports.messageTypeOptions = messageTypeOptions
